"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestStateOperation = exports.CurrencyCode = void 0;
var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["USD"] = "USD";
    CurrencyCode["EUR"] = "EUR";
    CurrencyCode["GBP"] = "GBP";
})(CurrencyCode || (exports.CurrencyCode = CurrencyCode = {}));
var RequestStateOperation;
(function (RequestStateOperation) {
    RequestStateOperation["Cancellation"] = "Cancellation";
    RequestStateOperation["PlanChange"] = "PlanChange";
    RequestStateOperation["Reactivation"] = "Reactivation";
    RequestStateOperation["TrialConversion"] = "TrialConversion";
    RequestStateOperation["ExpiredTrialConversion"] = "ExpiredTrialConversion";
})(RequestStateOperation || (exports.RequestStateOperation = RequestStateOperation = {}));
//# sourceMappingURL=common.js.map